/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Result_Group_Auto_ApprovedInputs */



/**
* | output |
* | --- |
* | "{count} actions ran without asking" |
*
* @param {Chat_Tool_Result_Group_Auto_ApprovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_result_group_auto_approved = /** @type {((inputs: Chat_Tool_Result_Group_Auto_ApprovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Result_Group_Auto_ApprovedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Aktionen ohne Rückfrage ausgeführt`)
	return /** @type {LocalizedString} */ (`${i?.count} actions ran without asking`)
});